import React from 'react'

export function usePromise(fnPromise, options = []) {
  const [isFetching, setIsFetching] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (isFetching) {
      if (typeof fnPromise === 'function') {
        fnPromise()
          .then(result => {
            setData(result);
          })
          .catch(err => {
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
            setIsFetching(false);
          });
      } else {
        setError('usePromise not resolve promise');
        setIsLoading(false);
        setIsFetching(false);
      }
    }
  }, [isFetching, ...options]);

  return { isLoading, data, error, setIsFetching };
}


// WEBPACK FOOTER //
// ./src/modules/hookUtils.js